module.exports = __webpack_public_path__ + "files/1bf67b3c29a241b9b8e37580a03e1b94.png";